import React from "react";
import '../Styles/AddPayment.scss';
import IndividualRegistrationPaymentInformation from "../Components/IndividualRegistrationPaymentInformation";
import DateHelpers from "../Helper/DateHelpers";
import InputValidation from "../Helper/InputValidation";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { AgGridReact } from 'ag-grid-react';
import { useNavigate, useLocation } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../Components/CheckoutForm";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Navbar from '../Components/Navbar';
import { Helmet } from "react-helmet";
import format from 'date-fns/format';
import { AutoScrollService } from "ag-grid-community";
import Session from 'react-session-api';

function AddPayment() {
   const location = useLocation()
   const navigate = useNavigate()
   const [paymentIntent, setPaymentIntent] = useState({})
   const [customerId, setCustomerId] = useState("")
   const [clientSecret, setClientSecret] = useState("")
   const options = { clientSecret }
   const stripePromise = loadStripe("pk_live_51Qj8NvRstlwNU15E4RDarYStMSEcfHxbadUFqI9kSoC2Ux263Q9MNwMSVwFVhPLMxYWzD6R5MZDH2Eet5lG6afAY00VDLdBkCa")
   const [amountDue, setAmountDue] = useState()
   const [paymentAmount, setPaymentAmount] = useState()
   const [registationFee, setRegistrationFee] = useState()
   const [campFee, setCampFee] = useState()
   const registInfo = location.state;
   console.log("registration info", registInfo)

   async function addPayment() {
      try {
         // Update Amount Due
         const response = await fetch('/updateamountdue', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               amountDue,
               registrationId: registInfo.queriedRegistration.registration_regist_id
            })
         })

         let registrationResult = await response.json();
         console.log("Registration result", registrationResult)

         // Add Transaction
         const transaction = await fetch('/addtransaction', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               transactionValue: paymentAmount,
               registId: registInfo.queriedRegistration.registration_regist_id,
               paymentType: "Credit",
               paymentIntentId: paymentIntent.id
            })
         })

         let transactionResult = await transaction.json();
         console.log("transaction result", transactionResult)
      }
      catch(ex){
         console.log("Exception", ex)
      }
      
      navigate('/daycamppaymentsuccess', { state: {paymentAmount}})
   }

   const fetchCustomer = async () => {
      let stripeCustomerId = await registerForEvent()
      console.log("Stripe customer id to be passed to the payment intent", stripeCustomerId)
      setCustomerId(stripeCustomerId)
   };

   async function registerForEvent() {
      let userEmail = registInfo.queriedRegistration.account_email_address
      console.log(userEmail, "Here is the user email", userEmail)
      var response = await fetch('api/createcustomer', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ email: userEmail }),
      });

      const data = await response.json();
      console.log('Stripe Customer ID:', data.stripeCustomerId);
      return data.stripeCustomerId; // Retrieve customer_id
   }

   const createPaymentIntent = async (customer_id, price) => {
      console.log(customer_id, "CUSTOMER_ID to be passed down to payment intent!")
      var response = await fetch('api/create-payment-intent', {
         method: 'POST',
         headers: { 'Content-type': 'application/json' },
         body: JSON.stringify({ customerId: customer_id, price: price, paymentOption: 'balance' })
      })

      const data = await response.json();
      console.log("data returned from payment intent", data)
      console.log('The Created Payment Intent: ', data.paymentIntentInfo)
      var clientSecretAndId = data.paymentIntentInfo;
      return { clientSecret: clientSecretAndId.clientSecret, id: clientSecretAndId.id };
   }

   const HandlePayment = () => {
      if (paymentIntent.status === "succeeded") {
         var amountOwed = parseInt(registInfo.queriedRegistration.registration_amount_due, 10)
         var pricePaid = InputValidation.shiftDecimalLeft(paymentIntent.amount, 2)
         setPaymentAmount(pricePaid)
         if(amountOwed == pricePaid)
         {
            console.log("condition true!!")
            setAmountDue(amountOwed - pricePaid)
         }
         
      }
   }


   // Display price options and credit card dropdown
   useEffect(() => {
      if (!location.state) {
         return
      }
      console.log("payment coming from dashboard!")
      fetchCustomer();
   }, [])

   useEffect(() => {
      const fetchPaymentIntent = async () => {
         if (!customerId) return;
         let totalDue = (registInfo.queriedRegistration.registration_amount_due * 100)
         console.log("totalDue", totalDue)
         let secret = await createPaymentIntent(customerId, totalDue);
         console.log("Received Client Secret:", secret)

         setClientSecret(secret.clientSecret)
      }
      fetchPaymentIntent();
   }, [customerId])

   // Get the response from Stripe, and calculate remaining amount due
   useEffect(() => {
      if (!paymentIntent) {
         return
      }
      console.log("payment Intent!!", paymentIntent)
      console.log("status", paymentIntent.status)
      HandlePayment()
   }, [paymentIntent])

   useEffect(() => {
      // Determine how you want to check this logic. Will work for now. 
      if ((amountDue != 0) || (!paymentAmount)) {
         return; 
      }

      console.log("use Effect Amount Due!!")
      console.log("payment Intent!!", paymentIntent)
      console.log("status", paymentIntent.status)
      console.log("amount due", amountDue)
      addPayment()
   }, [amountDue, paymentAmount])

   return (
      <div className="AddPaymentContainer">
         <div className="AddPaymentContent">
            <div className="AddPaymentHeading">
               Add Payment
            </div>
            <div className="AddPaymentAmount">
               Amount to Pay: ${registInfo.queriedRegistration.registration_amount_due}
            </div>
            <div>
               {clientSecret && (
                  <Elements stripe={stripePromise} options={options}>
                     <CheckoutForm
                        setPaymentIntent={setPaymentIntent} />
                  </Elements>
               )}
            </div>
         </div>
      </div>
   )
}

export default AddPayment